import { render, staticRenderFns } from "./horse.vue?vue&type=template&id=15186d35&"
import script from "./horse.vue?vue&type=script&lang=js&"
export * from "./horse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports